import { Pipe, PipeTransform } from '@angular/core';
import { isBoolean } from 'lodash-es';

import { NO_VALUE } from '@pipes';

import { FeatureConnectionService } from '../../services/feature-connection.service';

@Pipe({
  name: 'booleanSuffix',
  standalone: true,
})
export class BooleanSuffixPipe implements PipeTransform {
  constructor(private featureConnectionService: FeatureConnectionService) {}

  transform(value: any, ...args: string[][]): string {
    if (this.featureConnectionService.isErrorOrNotConnectedBasedOnTranslation(value)) {
      return value;
    }

    if (value !== null && value !== undefined && isBoolean(value)) {
      const truthyValue = args[0][0];
      const falsyValue = args[0][1];

      return value ? truthyValue : falsyValue;
    }

    return NO_VALUE;
  }
}
